import {ZadostiRozpracovaneInput, ZadostTyp} from '@eon.cz/apollo13-graphql-certifikovani-partneri';
import {createSelector, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {addMonths, format} from 'date-fns';
import {Store} from '../../../common/store/Store';
import {ZadostiSopWebSelectedLeftMenuType} from '../model/ZadostiModel';
import {ZadostiStore} from '../store/ZadostiStore';

export const initialState = {
    selectedLeftMenuType: ZadostiSopWebSelectedLeftMenuType.ROZPRACOVANE,
    openPodatZadost: false,
    filter: {
        ean: undefined,
        zakaznik: undefined,
        typ: ZadostTyp.ELEKTRINA_NOVY_TRVALY_ODBER_NN_CP,
        // vytvoreno od default dnes minus jeden měsíc
        vytvorenoOd: format(addMonths(new Date(), -1), 'yyyy-MM-dd'),
        vytvorenoDo: format(new Date(), 'yyyy-MM-dd'),
        odeslanoOd: format(addMonths(new Date(), -12), 'yyyy-MM-dd'),
        odeslanoDo: format(new Date(), 'yyyy-MM-dd'),
        vytvorilKid: undefined,
        stav: 'VSE',
    },
} as ZadostiStore;

export const zadostiSlice = createSlice({
    name: 'zadosti',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setZadostiSopWebSelectedLeftMenuType: (state: ZadostiStore, {payload}: PayloadAction<ZadostiSopWebSelectedLeftMenuType>): ZadostiStore => ({
            ...state,
            selectedLeftMenuType: payload,
        }),
        setZadostiSopWebPodatZadost: (state: ZadostiStore, {payload}: PayloadAction<boolean>): ZadostiStore => ({
            ...state,
            openPodatZadost: payload,
        }),
        setZadostiSopWebFilter: (state: ZadostiStore, {payload}: PayloadAction<ZadostiRozpracovaneInput | undefined>): ZadostiStore => ({
            ...state,
            filter: payload,
        }),
    },
});

export const {setZadostiSopWebSelectedLeftMenuType, setZadostiSopWebPodatZadost, setZadostiSopWebFilter} = zadostiSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example, `useSelector((state: RootState) => state.counter.value)`
export const zadosti = (state: Store) => state.zadosti;
export const selectZadosti = createSelector([zadosti], (zadosti) => zadosti);
